import communicationsApi from '../../api/communicationsApi'
import { Communication } from '../../types/communications'
import useCustomQuery from './useCustomQuery'
import { OptionsTypeReactQuery } from '../../types/api'

export enum CommunicationsServerStateKeysEnum {
  Communications = 'communications',
}

export const useGetCommunications = (contactId?: string | null, options?: OptionsTypeReactQuery<Communication[]>) =>
  useCustomQuery<Communication[], Error>(
    [CommunicationsServerStateKeysEnum.Communications, contactId],
    (header) => communicationsApi.getCommunications(contactId, header),
    options,
  )
